import './crossref';
import './open-citations';



// WEBPACK FOOTER //
// ./src/data-modules/index.js